import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { lazy, Suspense } from 'react'

const OrigTableSettings = lazy(() =>
  import('./EnhancedTableSettingsContainer').then(m => ({
    default: m.EnhancedTableSettingsContainer
  }))
)

export const EnhancedTableSettingsContainer = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <OrigTableSettings {...props} />
    </Suspense>
  )
}
